import { render, staticRenderFns } from "./centres.vue?vue&type=template&id=10c3b922"
import script from "./centres.vue?vue&type=script&lang=ts"
export * from "./centres.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports